import React, { useState, useEffect } from "react";
import Navbar from '../components/Navbar';


export default function Root() {
  
  return (
    
    <>
     
    <Navbar />
          </>

  )
}
